import Link from '~/components/ui/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from '~/components/layout/PageStructure';

export const Hero = ({ data }) => {
  const { settings } = data;
  const { title, subtitle, cta, uri } = settings;

  return (
    <section className="py-7">
      <Container className="grid justify-items-center text-center">
        {title && (
          <div className="pb-4 prose">
            <h1>{title}</h1>
          </div>
        )}
        {subtitle && (
          <div className="grid grid-cols-6 gap-4">
            <div className="col-span-6 md:col-span-4 md:col-start-2">
              <div
                className="py-2 prose"
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            </div>
          </div>
        )}
        {cta && uri && (
          <Link
            className="button relative button--primary rounded button--regular mt-4"
            ignoreRouter={true}
            to={uri}
          >
            {cta}
          </Link>
        )}
      </Container>
    </section>
  );
};

Hero.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    cta: PropTypes.string,
    uri: PropTypes.string,
  }),
};
